import { Divider, Typography } from '@mui/material'
import React from 'react'
import { useParams } from 'react-router-dom'
import Zone from '../organisms/Zone'
import ImageList from '../molecules/ImageList'
import TitleSubtitle from '../molecules/TitleSubtitle'
import useDefault from '../../hooks/useDefault'
import useDefaultDetails from '../../hooks/useDefaultDetail'
import { SERVICES } from '../../constants'

const Project = () => {
	const { slug } = useParams()
	let { pageNumber } = useParams()

	pageNumber = pageNumber || 1

	const projects_per_page = 8
	const { data: projets } = useDefault(SERVICES.PROJECT, pageNumber, projects_per_page)
	const { data: projet } = useDefaultDetails(SERVICES.PROJECT_DETAIL, slug)
	return (
		<>
			{projet &&
				projet?.list.map(({ title, content }, index) => (
					<Zone color="white" key={index}>
						<Typography
							variant="h4"
							color="text.primary"
							sx={(theme) => ({
								fontSize: 44,
								fontWeight: 800,
								[theme.breakpoints.down('md')]: {
									fontSize: 24,
								},
							})}
							dangerouslySetInnerHTML={{ __html: title }}
						/>
						<Typography
							color="text.primary"
							sx={(theme) => ({
								'& p, & li': {
									textAlign: 'left',
									fontSize: 18,
									fontWeight: 400,
									m: (theme) => theme.spacing(2, 50),
									[theme.breakpoints.down('md')]: {
										mx: 0,
										fontSize: 16,
									},
								},
								'& figure': {
									maxWidth: 648,
									mx: 'auto',
									my: 5,
								},
							})}
							dangerouslySetInnerHTML={{ __html: content }}
						/>
					</Zone>
				))}
			<Divider sx={{ mx: 15, border: 1, color: 'text.primary' }} />
			{projets?.list && (
				<Zone
					sx={{
						borderRadius: 0,
						textAlign: 'center',
						p: (theme) => theme.spacing(20, 14, 10, 14),
						bgcolor: 'text.white',
					}}
				>
					<TitleSubtitle title="Nos projets" subtitle="Découvrez nos autres projets" />
					<ImageList list={projets?.list} />
				</Zone>
			)}
		</>
	)
}

export default Project
